import { render, staticRenderFns } from "./cope-with-submission-list.vue?vue&type=template&id=147920b0&scoped=true&"
import script from "./cope-with-submission-list.vue?vue&type=script&lang=js&"
export * from "./cope-with-submission-list.vue?vue&type=script&lang=js&"
import style0 from "./cope-with-submission-list.vue?vue&type=style&index=0&id=147920b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147920b0",
  null
  
)

export default component.exports